import { render, staticRenderFns } from "./HorizontalScrollablePage.vue?vue&type=template&id=6878d0dd&"
import script from "./HorizontalScrollablePage.vue?vue&type=script&lang=js&"
export * from "./HorizontalScrollablePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports